export const LAYER_CONFIG_OMIT_PROP = ['name', 'data', 'onClick', 'onHover', 'onLoaded', 'onLoadFailed'];

// base默认最小层级
export const BASE_MIN_ZOOM = 3;
// base默认最大层级
export const BASE_MAX_ZOOM = 25;
// base中WMTS默认服务
export const WMTS_SERVICE = 'geoserver';
// base中3stiles
export const BASE_COMMON_SPACE = true;
// base中3stiles加载精度
export const BASE_MAXIMUM_SCREEN = 1;
// base中3stiles是否开启阴影
export const BASE_CAST_SHADOW = false;

// 默认style
export const markerStyle = {
  width: 12, // 标注点图片宽度
  height: 12, // 标注点图片高度
  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAZRJREFUWEfNl+1dAjEMxv+5CXADmECcQN1AJ/DAAcQJxAnEBaBOoE6gTgAbyAbeAl781VKPlzuoWjj6tU+TJ29NIoSeVBsknAHHCG2UJtCYPc8QpigThFc+ecZIFiJaNoJSbSL0EC7mFG58BhhybjEyXQeuJuAsvgF6IdrWYAYM5brqvpyAtTrhBb7dHONMyTkt88YqgVTbJDxGVO4NsCTOMTKZt2iRQHzLl7234omCgIv5eAuWl5E48lVSEOjqXYSEC82Xn8R0BJzr30NfR8HltGxSOgIdNbM6jyI7SIhyz0h6gov9R9CjuKCMnJbQ1RQYxZUdLK0jtbi/4GeESx2jtIM5xwQKExsCG3/f1WKKD5GVWQIagtwWZi8I1ByC2pOwjl9woQzr/IiE1H/FthHtvhRzDnwzGiBcbavUKuQahtLZk3bsWvLuvDBrxVbtHo1kxWQUcxz/xVDqobWO5QWJGheTgkQDof/v8rQJp/SrltXQ5dQSsctp6MlQHlAGf19Ol1X59Vw5IeGwcj2HN3KeQtfzL9gzo0MLtTfGAAAAAElFTkSuQmCC', // 标注点图片url或base64地址，若为url地址图片一定要在服务器端配置允许跨域
  color: '#0062FF',
  opacity: 1,
};
export const polylineStyle = {
  color: '#0062ff', // 线填充色，支持rgb()，rgba()，#RRGGBB等形式
  dashArray: [0, 0], // 虚线展示方式，[0, 0]为实线，[10, 10]表示十个像素的实线和十个像素的空白（如此反复）组成的虚线，默认为[0, 0]
  width: 2, // 线宽度，正整数
};
export const polygonStyle = {
  color: 'rgba(0,98,255,0.1)', // 面填充色，支持rgb()，rgba()，#RRGGBB等形式
  borderColor: '#0062ff', // 边线颜色，支持rgb()，rgba()，#RRGGBB等形式
  borderWidth: 2, // 边线宽度，正整数
  borderDashArray: [0, 0], // 虚线展示方式，[0, 0]为实线，[10, 10]表示十个像素的实线和十个像素的空白（如此反复）组成的虚线，默认为[0, 0]
};
/**
 * 二期新增Hightlight高亮样式
 * markerStyleHighlight、polylineStyleHighlight、polygonStyleHighlight
 */
export const markerStyleHighlight = {
  width: 12, // 标注点图片宽度
  height: 12, // 标注点图片高度
  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAZRJREFUWEfNl+1dAjEMxv+5CXADmECcQN1AJ/DAAcQJxAnEBaBOoE6gTgAbyAbeAl781VKPlzuoWjj6tU+TJ29NIoSeVBsknAHHCG2UJtCYPc8QpigThFc+ecZIFiJaNoJSbSL0EC7mFG58BhhybjEyXQeuJuAsvgF6IdrWYAYM5brqvpyAtTrhBb7dHONMyTkt88YqgVTbJDxGVO4NsCTOMTKZt2iRQHzLl7234omCgIv5eAuWl5E48lVSEOjqXYSEC82Xn8R0BJzr30NfR8HltGxSOgIdNbM6jyI7SIhyz0h6gov9R9CjuKCMnJbQ1RQYxZUdLK0jtbi/4GeESx2jtIM5xwQKExsCG3/f1WKKD5GVWQIagtwWZi8I1ByC2pOwjl9woQzr/IiE1H/FthHtvhRzDnwzGiBcbavUKuQahtLZk3bsWvLuvDBrxVbtHo1kxWQUcxz/xVDqobWO5QWJGheTgkQDof/v8rQJp/SrltXQ5dQSsctp6MlQHlAGf19Ol1X59Vw5IeGwcj2HN3KeQtfzL9gzo0MLtTfGAAAAAElFTkSuQmCC', // 标注点图片url或base64地址，若为url地址图片一定要在服务器端配置允许跨域
  color: '#0062ff',
  opacity: 1,
};
export const polylineStyleHighlight = {
  color: 'rgba(0,98,255,0.3)', // 线填充色，支持rgb()，rgba()，#RRGGBB等形式
  dashArray: [0, 0], // 虚线展示方式，[0, 0]为实线，[10, 10]表示十个像素的实线和十个像素的空白（如此反复）组成的虚线，默认为[0, 0]
  width: 2, // 线宽度，正整数
};
export const polygonStyleHighlight = {
  color: 'rgba(0,98,255,0.05)', // 面填充色，支持rgb()，rgba()，#RRGGBB等形式
  borderColor: 'rgba(0,98,255,0.5)', // 边线颜色，支持rgb()，rgba()，#RRGGBB等形式
  borderWidth: 2, // 边线宽度，正整数
  borderDashArray: [0, 0], // 虚线展示方式，[0, 0]为实线，[10, 10]表示十个像素的实线和十个像素的空白（如此反复）组成的虚线，默认为[0, 0]
};
export const labelStyle = {
  color: '#232A4A', // 颜色属性，支持rgb()，rgba()，#RRGGBB等形式
  size: 14, // 文字大小属性
  offset: { x: 0, y: -20 },
};
export const mvtPolygonStyle = {
  'fill-color': 'rgba(0,98,255,0.1)', // 填充颜色，支持rgb()，rgba()，#RRGGBB等形式
  'fill-outline-color': '#0062ff', // 边框颜色
};
export const mvtLineStyle = {
  'line-color': '#0062ff', // 颜色属性
  'line-width': 2,
};
export const mvtMarkerStyle = {
  'circle-radius': 6,
  'circle-color': '#0062ff',
};
